import { Typography } from '@atlas-metrics/design-system';

export type AtlasFooterLinkProps = {
  text: string;
  path: string;
};

const AtlasFooterLink: React.FC<AtlasFooterLinkProps> = ({ text, path }) => {
  return (
    <a
      href={`https://www.atlasmetrics.io/${path}`}
      target='_blank'
      rel='noopener noreferrer'
    >
      <Typography
        variant='body-s'
        className='pb-4 text-ds-grey-600 underline hover:text-white webS:py-6'
      >
        {text}
      </Typography>
    </a>
  );
};

export default AtlasFooterLink;
